













import { Component, Prop, Mixins } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import { CMMF, EPromotionStatus, SelectedCMMF } from '@/services/connecteur'
import lodash from 'lodash'
import promotionModule from '@/store/modules/PromotionModule'
import codeFormat from '@/filters/cmmfCodeFormat'
import TemplateItemCMMF from '@/components/Promotions/TemplateItemCMMF.vue'

@Component({
  components: { TemplateItemCMMF },
  filters: {
    codeFormat
  }
})
export default class CMMFRowCode extends Mixins(BaseVue) {
  @Prop({ required: true })
  public value!: SelectedCMMF

  @Prop()
  public promotionStatus!: EPromotionStatus

  @Prop({ default: false })
  public disabled!: boolean

  public currentCMMF: CMMF | undefined = new CMMF()
  public allCMMFSameReference: CMMF[] = new Array<CMMF>()
  public cacheObserver: any

  public get showSelect () {
    return (
      !this.disabled &&
      this.allCMMFSameReference.length > 1 &&
      (this.promotionStatus === EPromotionStatus.NEW ||
        this.promotionStatus === EPromotionStatus.DRAFT ||
        this.promotionStatus === EPromotionStatus.REWORK ||
        this.promotionStatus === EPromotionStatus.CHANGED)
    )
  }

  public mounted () {
    promotionModule.callbacks.push(this.updateReference)
    this.updateReference()
  }

  public beforeDestroy () {
    const index = promotionModule.callbacks.findIndex(
      this.updateReference
    )
    if (index >= 0) {
      promotionModule.callbacks.splice(index, 1)
    }
  }

  public updateReference () {
    const allCMMF = lodash(promotionModule.cmmfCache)
      .flatMap()
      .flattenDeep()
      .value()

    this.currentCMMF = allCMMF.find(c => c.code === this.value.code)
    this.allCMMFSameReference = allCMMF.filter(
      c =>
        c.longCommercialCode !== '' &&
        c.longCommercialCode?.substring(0, 6) ===
        this.value.longCommercialCode?.substring(0, 6)
    )
  }

  public updateSelectedCMMF () {
    const newValue = new SelectedCMMF({
      id: this.value.id,
      cmmfId: this.currentCMMF?.id,
      longCommercialCode: this.currentCMMF?.longCommercialCode,
      familyLevelOne: this.currentCMMF?.familyCode,
      plant: this.currentCMMF?.plant,
      productName: this.currentCMMF?.productName,
      cmmfGroup: this.currentCMMF?.cmmfGroup,
      code: this.currentCMMF?.code,
      quantity: this.value.quantity,
      kamComment: this.value.kamComment,
      flagSupply: this.value.flagSupply,
      dpComment: this.value.dpComment,
      snpComment: this.value.snpComment,
      supplyDeadline: this.value.supplyDeadline
    })
    this.$emit('update:value', {
      old: this.value,
      new: newValue
    })
  }
}
